module.exports = __webpack_public_path__ + "static/media/day28_gooey.204a071b.gif";